export const FIELD_TYPES = {
  header: 'header',
  select: 'select',
  text: 'text',
  textarea: 'textarea',
  date: 'date',
  time: 'time',
  radioGroup: 'radio-group',
  checkboxGroup: "checkbox-group",
  file: 'file',
  grid: 'grid',
  initialValues: "rules",
  rulesPrice: 'rulesprice',
}


export const RULE_LIST = {
  '0': 'ocultar',
  '1': 'visualizar',
  '2': 'inhabilitado',
  '3': 'habilitado',
  '4': 'requerido',
  '5': 'clickear',
  '6': 'no Requerido',
  '7': 'limpiar',
  '8': 'cambiarACedula',
  '9': 'cambiarAPasaporte',
  '10': 'cambiarARnc',
}

//How it's set in DB
export const MASK_LIST = {
  '0': 'Cédula',
  '1': 'RNC',
  '2': 'telefono',
  '3': 'celular',
  '5': 'email',
  '6': 'solo numero',
  '7': 'solo letra',
  '8': 'inmueble',
  '9': 'diffEmail',
  '10': 'fecha',
  '17': 'latitud',
  '18': 'longitud',
  '11': 'hora',
  '12': 'decimal',
  '20': "dpp",
  '21': "mimarena",
  '24': "preventSelect",
}

export const MASK_TYPE = {
  '0': 'identification',
  '1': 'rnc',
  '2': 'phone',
  '3': 'phone',
  // '5': 'email',
  '6': 'solo numero',
  // '7': 'solo letra',
  // '8': 'inmueble',
  // '9': 'COD.sistema caasd',
  // '10': 'fecha',
  // '11': 'hora',
  // '12': 'decimal',
  '17': 'latitud',
  '18': 'longitud',
}
